import { ChevronRight, Moon, Sun } from "lucide-react";
import NAV from "../theme/navConfig";
import { useAuth } from "../context/AuthContext";
import T from "../theme/colors";
import { useTheme } from "../context/ThemeContext";

/**
 * TopBar — minimal: breadcrumb, dark toggle, user pill.
 *
 * Previously had a global barcode lookup search + notification bell;
 * removed Apr 29 2026 since neither was being used in the wild.
 */

export default function TopBar({ page }) {
  const { user } = useAuth();
  const { isDark, toggle } = useTheme();
  const label = NAV.flatMap(g => g.items).find(i => i.id === page)?.label || "";

  return (
    <div style={{
      height: 54, background: "var(--bg-card)", borderBottom: `1px solid var(--border)`,
      display: "flex", alignItems: "center", justifyContent: "space-between",
      padding: "0 24px", flexShrink: 0, gap: 16,
      boxShadow: "0 1px 0 rgba(0,0,0,0.04)",
    }}>
      {/* Breadcrumb */}
      <div style={{ display: "flex", alignItems: "center", gap: 6, minWidth: 0 }}>
        <span style={{ fontSize: 14, color: "var(--text-2)" }}>Garment ERP</span>
        <ChevronRight size={12} style={{ color: "var(--text-2)" }} />
        <span style={{ fontSize: 15, fontWeight: 500, color: "var(--text-0)", fontFamily: "var(--font-ui)" }}>
          {label}
        </span>
      </div>

      {/* Right */}
      <div style={{ display: "flex", alignItems: "center", gap: 10, flexShrink: 0 }}>
        {/* Dark mode toggle */}
        <button onClick={toggle} title={isDark ? "Light mode" : "Dark mode"} style={{
          background: "var(--bg-hover)", border: `1px solid var(--border)`, borderRadius: 7,
          padding: 7, cursor: "pointer", display: "flex", transition: "border-color 0.14s",
        }}
          onMouseEnter={e => (e.currentTarget.style.borderColor = "var(--border-hover)")}
          onMouseLeave={e => (e.currentTarget.style.borderColor = "var(--border)")}>
          {isDark ? <Sun size={15} style={{ color: "var(--warn)" }} /> : <Moon size={15} style={{ color: "var(--text-1)" }} />}
        </button>

        {/* Divider */}
        <div style={{ width: 1, height: 22, background: "var(--border)" }} />

        {/* User pill */}
        <div style={{
          display: "flex", alignItems: "center", gap: 8, cursor: "pointer",
          padding: "4px 10px 4px 4px", borderRadius: 8,
          border: `1px solid var(--border)`, background: "var(--bg-card)",
          transition: "border-color 0.14s",
        }}
          onMouseEnter={e => (e.currentTarget.style.borderColor = "var(--border-hover)")}
          onMouseLeave={e => (e.currentTarget.style.borderColor = "var(--border)")}
        >
          <div style={{
            width: 26, height: 26, borderRadius: "50%", background: "var(--grad)",
            display: "flex", alignItems: "center", justifyContent: "center",
            fontSize: 12, fontWeight: 700, color: "#fff",
            fontFamily: "var(--font-ui)", flexShrink: 0,
          }}>
            {user?.fullName?.split(" ").map(n => n[0]).join("").slice(0, 2).toUpperCase() || "??"}
          </div>
          <div>
            <div style={{ fontSize: 14, fontWeight: 600, color: "var(--text-0)", lineHeight: 1.2, whiteSpace: "nowrap" }}>
              {user?.fullName?.split(" ")[0] || "User"}
            </div>
            <div style={{ fontSize: 12, color: "var(--text-2)" }}>
              {user?.companyName || "Garment ERP"}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}